import { Log, Rect, Size ,MyPIXIContainer } from ".././MyHelpers";
import { Resource } from "./Resource";
export class ImageResource extends Resource
{
	//private parent: HTMLElement = null;
	//private cssElem: HTMLElement = null;
	public get Name(): string {
		return this.name;
	}
	public get Type(): string {
		return "img"
	}

	public img: HTMLImageElement = null;
	public decoded: boolean = false;

	public constructor(path: string, name: string = null, required: boolean = true) {
		super(path, name, required)
	}

	public Load(preventCache: boolean = false): void {
		this.img = new Image();
        this.img.crossOrigin = "anonymous";
		this.img.onload = () => 
		{
			// image is loaded, but now need to decode it

			// Do not decode images in advance...
			// // try to decode, if not its ok
			// try
			// {
			// 	this.img.decode().then(
			// 		// success
			// 		() => {
			// 			this.decoded = true;
			// 			this.Loaded();
			// 		},

			// 		// error
			// 		() => this.Loaded()
			// 	);
			// }
			// catch (ex)
			// {
			// 	// error decoding, but loaded anyway
			// 	this.Loaded();
			// }

			this.Loaded();
		}
	    this.img.onerror = () => this.LoadError();

	    // set path last, loads by itself
	    this.img.src = this.path;
	}

	public Reload(preventCache: boolean = false):  void {
		this.Load(preventCache);
	}

	CssBackground(): string {
		return "url(" + this.path + ")";
	}

	Inline(elementClass:string):string
	{
		return '<span class="'+elementClass+'" style="background-image:url('+this.path+')"></span>';
	}
}

export class DecodedImageResource extends ImageResource
{
	public override get Name(): string {
		return this.name;
	}
	public override get Type(): string {
		return "img"
	}

	protected decodedSize: Size;
	protected decodedRect: Rect;
	protected decodedImage: ImageBitmap;

	public constructor(path: string, name: string = null, decodedSize: Size = null) {
		super(path, name, true)

		this.decodedSize = this.decodedSize;
	}

	public override Load(preventCache: boolean = false): void {
		this.img = new Image();
        this.img.crossOrigin = "anonymous";
		this.img.onload = () => 
		{
			let options: any = {};
			if (this.decodedSize)
			{
				this.decodedRect = new Rect(0, 0, this.decodedSize.Width, this.decodedSize.Height);
				options = {
					resizeWidth: this.decodedSize.Width,
					resizeHeight: this.decodedSize.Height
				};
			}
			else
			{
				// not resizing, save original size
				this.decodedSize = new Size(this.img.width, this.img.height);
				this.decodedRect = new Rect(0, 0, this.img.width, this.img.height);
			}


			createImageBitmap(this.img, 0, 0, this.img.width, this.img.height/*, options*/).then((decodedImage: ImageBitmap) => {
				this.decodedImage = decodedImage;
				(this.decodedImage as any)._pixiId = this.name + "_decoded";
				this.Loaded();
			})
			.catch((reason) => {
				Log.Error("IMG TODO", "Decoding whole image failed");
				this.LoadError();
			});
		}
	    this.img.onerror = () => this.LoadError();

	    // set path last, loads by itself
	    this.img.src = this.path;
	}

	public DecodedImage(): ImageBitmap
	{
		return this.decodedImage;
	}

	public DecodedSize(): Size
	{
		return this.decodedSize;
	}

	public DecodedRect(): Rect
	{
		return this.decodedRect;
	}
}
